//Library Imports
import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

//Local Imports
import Pills from "./Components/Pills";

interface PillTabsProps {}

const PillTabs: React.FC<PillTabsProps> = (props) => {
  return (
    <TabsWrapper className="d-flex padding-top-md padding-bottom-lg">
      <ul>
        <li>
          <Link to={"/audiences"}>
            <Pills title="Dashboard" active="true" />
          </Link>
        </li>
        <li>
          <Link to={"/audiences/accounts"}>
            <Pills title="Accounts" />
          </Link>
        </li>
        <li>
          <Link to={"/audiences/lists"}>
            <Pills title="Lists" />
          </Link>
        </li>
        <li>
          <Link to={"/audiences/people"}>
            <Pills title="People" />
          </Link>
        </li>
      </ul>
    </TabsWrapper>
  );
};

export default PillTabs;

const TabsWrapper = styled.div`
  justify-content: space-between;
  align-items: center;
  margin-left: -5px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding-bottom: 12px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    li {
      margin: 5px 5px;
    }
  }
  p.articles-count {
    margin-bottom: 0px;
    color: rgb(126, 126, 126);
    font-size: 14px;
    font-weight: 600;
    font-family: "robotomedium";
    white-space: nowrap;
    display: inline-block;
    float: right;
  }
`;
